<template>
  <div class="col-2">
    <h1>
      <span class="acier">{{ collection_title }}</span>
    </h1>
    <div v-if="cover" ref="cover_image">
      <img :src="cover" alt="" />
    </div>
    <div v-else-if="collection_description" ref="cover_image">
      <img src="~@/assets/img/default.png" alt="" />
    </div>
    <div
      v-if="desc_height"
      class="text-up"
      :style="'height:' + desc_height + 'px'"
    >
      <p
        v-if="collection_description && !collection_abstract"
        v-html="collection_description"
      />
      <p v-if="collection_abstract">{{ collection_abstract }}</p>

      <div v-if="collection_abstract" class="show-more" @click="showMore()">
        Pokaż cały opis
      </div>
      <div class="icon-links to-right">
        <a :href="null" v-if="null"><i class="icon-fb"></i></a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NProgress from "nprogress";
import { eventBus } from "@/main.js";

export default {
  name: "CollectionHead",
  data() {
    return {
      collection_title: null,
      collection_description: null,
      collection_abstract: null,
      cover: null,
      desc_height: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    showMore() {
      eventBus.$emit("plsResetGrid");
      this.collection_abstract = null;
    },
    fetchData() {
      NProgress.start();

      axios
        .get(this.$config.API_PATH + "collections/" + this.$route.params.id)
        .then((_resp) => {
          if (_resp.length == 0) {
            this.$router.push({
              name: "NotFound",
            });
          }

          let _metadata = _resp.data.element_texts;
          if (_metadata.find((x) => x.element.id == "50"))
            this.collection_title = _metadata.find(
              (x) => x.element.id == "50"
            ).text;
          if (_metadata.find((x) => x.element.id == "41"))
            this.collection_description = _metadata.find(
              (x) => x.element.id == "41"
            ).text;



/*           if (this.collection_description.length > 100 && null) {
            let regex = /(<([^>]+)>)/gi;
            this.collection_abstract =
              this.collection_description
                .replace(regex, "")
                .split(" ")
                .slice(0, 20)
                .join(" ") + " [...]";
          }
 */
          // get cover image

          this.cover = _resp.data.cover_img;
          //console.log(_resp)

          if (this.cover) {
            let img = new Image();
            img.src = _resp.data.cover_img;
            let _this = this;
            img.onload = () => {
              _this.desc_height = _this.$refs.cover_image.clientHeight;
              eventBus.$emit("headLoaded");
              NProgress.done();
            };
          } else {
            //_this.desc_height
              eventBus.$emit("headLoaded");
              NProgress.done();
          }




        })
        .catch((error) => {
          //console.log(error)
          this.$router.push({
            name: "NotFound",
          });
        });

    },
  },
};
</script>

<style scoped>
.text-up p a {
  color: red;
}
.show-more {
  cursor: pointer;
}
.show-more:hover {
  color: #c63 !important;
}
.text-up {
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 5px;
}

/* Works on Firefox */
.text-up {
  scrollbar-width: thin;
  scrollbar-color: #c63 #465165;
}

/* Works on Chrome, Edge, and Safari */
.text-up::-webkit-scrollbar {
  width: 12px;
}

.text-up::-webkit-scrollbar-track {
  background: #465165;
}

.text-up::-webkit-scrollbar-thumb {
  background-color: #c63;
  border-radius: 0px;
  border: 1px solid #465165;
}
</style>


// WEBPACK FOOTER //
// src/components/Heads/CollectionHead.vue